import { styled } from '@mui/material/styles'
import React from 'react'

import Colors from '#/styles/Colors'

import DatasheetSkeleton from './skeleton'
import TypesDatasheet from './types'

const CardContainer = styled('div')({
  padding: '25px 20px',
  color: 'white',
  borderRadius: 16,
  marginRight: 16,
  marginBottom: 16,
  backgroundColor: Colors.darkerGray,
})

const MainList = styled('ul')({
  margin: 0,
  padding: 0,
  listStyleType: 'none',
})

const NestedList = styled('ul')(({ theme }) => ({
  paddingLeft: theme.spacing(2),
}))

const ListItemContainer = styled('li')({
  'margin': 0,
  '&:not(:last-of-type)': {
    paddingBottom: 20,
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  '&:not(:first-of-type)': {
    paddingTop: 20,
  },
})

const ItemTitle = styled('p')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: 16,
  color: theme.palette.primary.main,
  margin: 0,
  marginBottom: 6,
}))

const DataItem = styled('li')({
  alignItems: 'center',
  padding: '2px 0',
  display: 'flex',
})

const DataTitle = styled('span')({
  fontWeight: 'bold',
  marginRight: 5,
})

const SubItem = styled(DataItem)(({ theme }) => ({
  display: 'list-item',
  fontSize: 13,
  marginLeft: theme.spacing(2),
}))

const DataValue = styled('span')({
  display: 'inline-flex',
})

const subItemList = ['last_reproduction_method', 'last_insemination_semen', 'donor']

export const DatasheetContent = ({ AnimalData, loading }) => {
  return (
    <CardContainer>
      <MainList>
        {AnimalData && !loading ? (
          AnimalData?.map(({ title, data }) => {
            return (
              <ListItemContainer key={title}>
                <ItemTitle>{title}</ItemTitle>
                <div>
                  <NestedList>
                    {data.map(({ title, id, value }, index) => {
                      const isSubItem = subItemList.includes(id)
                      const ItemComponent = isSubItem ? SubItem : DataItem

                      return (
                        <ItemComponent key={id + index}>
                          {isSubItem && <span>└ </span>}
                          <DataTitle>{title}:</DataTitle>
                          <DataValue>
                            <TypesDatasheet id={id} value={value} />
                          </DataValue>
                        </ItemComponent>
                      )
                    })}
                  </NestedList>
                </div>
              </ListItemContainer>
            )
          })
        ) : (
          <DatasheetSkeleton />
        )}
      </MainList>
    </CardContainer>
  )
}
